import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer group">
              <span className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-400"></i>
              </span>
              <span className="font-heading text-xl text-white whitespace-nowrap">芒果视频</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              芒果视频是您最好的免费在线观影平台，替代西瓜视频免费和91视频，提供海量高清影视资源。电影、电视剧、综艺、动漫，全部免费播放不收费。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-white text-base mb-4">
              <a href="#footer-categories" className="no-underline text-inherit">视频分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.filter(c => c.id !== 'all').map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-white text-base mb-4">
              <a href="#footer-links" className="no-underline text-inherit">快捷链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">热门电影</Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">最新电视剧</Link>
              </li>
              <li>
                <Link to="/category/anime" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">热门动漫</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-white text-base mb-4">
              <a href="#footer-contact" className="no-underline text-inherit">联系我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-xs"></i>
                </span>
                contact@mangovideo.com
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-xs"></i>
                </span>
                400-888-6666
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-xs"></i>
                </span>
                北京市朝阳区望京科技园A座18层
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 芒果视频 mangovideo.com — 免费在线视频平台，西瓜视频免费与91视频优质替代
          </p>
          <div className="flex items-center gap-4">
            <a href="https://weixin.qq.com" target="_blank" rel="nofollow noopener noreferrer" className="text-background-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer" aria-label="微信">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-wechat-line"></i>
              </span>
            </a>
            <a href="https://weibo.com" target="_blank" rel="nofollow noopener noreferrer" className="text-background-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer" aria-label="微博">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-weibo-line"></i>
              </span>
            </a>
            <a href="https://www.douyin.com" target="_blank" rel="nofollow noopener noreferrer" className="text-background-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer" aria-label="抖音">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-tiktok-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}